import React from 'react';
import { Link } from 'react-router-dom'; 

const Dashboardhome = () => {
  return (
    <div className="container-fluid">  
        <div className="row">
          <div className="col-xl-4 col-sm-6">
            <div className="card card-default card-mini">
              <Link to="new-pan-application">
              <div className="card-header text-center">
                
                <i className="display-6 mdi mdi-account-card-details mr-3 color-icon"></i><br />
                
                          
                <Link to="new-pan-application" className="text-color">New PAN Application</Link>
              </div>
              </Link>
            </div>
          </div>
          <div className="col-xl-4 col-sm-6">
            <div className="card card-default card-mini">
              <Link to="correction-pan-application">
              <div className="card-header text-center">
                  <i className="display-6 mdi mdi-account-card-details mr-3 color-icon"></i><br />
                  <Link to="correction-pan-application" className="text-color">Correction PAN Application</Link>
                </div>
              </Link>
            </div>
          </div>
          <div className="col-xl-4 col-sm-6">
            <div className="card card-default card-mini">
               <Link to="name-publication">
               <div className="card-header text-center">
                
                 <i className="display-6 mdi mdi-account-card-details mr-3 color-icon"></i><br />
                 
                          
                <Link to="name-publication" className="text-color">Name Publication</Link>
              </div>
              </Link>
            </div>
          </div>
          <div className="col-xl-4 col-sm-6">
            <div className="card card-default card-mini">
             <Link to="pan-find" >
               <div className="card-header text-center">
                          <i className="display-6 mdi mdi-account-card-details mr-3 color-icon"></i> <br />
                <Link to="pan-find" className="text-color">PAN Find</Link>
              </div>
              </Link>
            </div>
          </div>
          <div className="col-xl-4 col-sm-6">
            <div className="card card-default card-mini">
               <Link to="pan-object" >
                  <div className="card-header text-center">
                  <i className="display-6 mdi mdi-account-card-details mr-3 color-icon"></i><br />        
                  <Link to="pan-object" className="text-color">PAN Object</Link>
                </div>
              </Link>
            </div>
          </div>
          <div className="col-xl-4 col-sm-6">
            <div className="card card-default card-mini">
               <Link to="camp-registration">
              <div className="card-header text-center">
                  <i className="display-6 mdi mdi-account-card-details mr-3 color-icon"></i><br />
                <Link to="camp-registration" className="text-color">CAMP Registration</Link>
              </div>
              </Link>
            </div>
          </div>
        </div>
     </div>
  );
};

export default Dashboardhome;
